// /pages/carrossier/FormulaireB/components/SectionCleverSafe.js
import React from "react";
import RadioGroup from "./shared/RadioGroup";

const SectionCleverSafe = ({ formData, handleControleChange, productId }) => {
  return (
    <section className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200">
      <h3 className="text-lg font-semibold mb-6 text-green-600 flex items-center gap-2">
        <span className="text-xl">🛡️</span>
        9. Système CLEVER SAFE
      </h3>
      
      <div className="bg-green-50 p-4 rounded-xl mb-6 border border-green-200">
        <div className="grid grid-cols-4 gap-4 font-semibold text-sm text-green-800">
          <span>Élément à contrôler</span>
          <span className="text-center">O (Oui)</span>
          <span className="text-center">So (Sans objet)</span>
          <span className="text-center">N (Non)</span>
        </div>
      </div>
      
      <div className="space-y-1">
        {[
          ["A", "Plaque CE intérieur coffret"],
          ["B", "Fixation du vérin"],
          ["C", "Test commande extérieure montée"],
          ["D", "Test commande extérieure descente"],
          ["E", "Test commande Safe On/Off"],
          ["F", "Test montée par impulsion (option)"],
          ["G", "Test commande intérieure caisse montée"],
          ["H", "Position du vérin par rapport au cadre"],
          ["I", "Contrôle position alignement du vérin"],
          ["J", "Serrage embase"],
          ["K", "Serrage chape"],
          ["L", "Serrage barre de liaison et contre écrou"],
          ["M", "Renfort sur section haute"],
          ["N", "Fixation coffret de commande"],
          ["O", "Fusible de protection batterie"],
          ["P", "Buzzer porte ouverte"],
          ["Q", "Capteur de fin de course porte ouverte"]
        ].map(([code, label]) => 
          <RadioGroup
            key={`systemeCleverSafe-${code}`}
            controle="systemeCleverSafe"
            field={code}
            label={`${code} - ${label}`}
            formData={formData}
            handleControleChange={handleControleChange}
            productId={productId}
            color="green"
          />
        )}
      </div>
    </section>
  );
};

export default SectionCleverSafe;